﻿"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const form_controls_1 = require("@its-suite/form-controls");
class PasswordField extends React.Component {
    render() {
        let _a = this.props, { prefixId, validators } = _a, rest = __rest(_a, ["prefixId", "validators"]);
        return (React.createElement(form_controls_1.TextField, Object.assign({ type: 'password', validators: this.props.disabled ? [] : this.props.validators, id: form_controls_1.IdentifierHelpers.createId(this.props.prefixId, form_controls_1.IdentifierHelpers.IdForElement.TextField, [this.props.name]) }, rest)));
    }
}
exports.PasswordField = PasswordField;
PasswordField.defaultProps = {
    className: '',
    disabled: false
};
//# sourceMappingURL=PasswordField.js.map